import { faStopwatch,faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FC, memo } from "react";
import styled from "styled-components";
import Timer from "../_shared/Timer";
import { IAgentProperties } from "../../../models/BlenderAgentStateModel";
import { dxpLayout } from "../../../style/theme";

interface IProps {
  agentProperties: IAgentProperties;
}

const RootContainer = styled.div`
  height: 100%;
`;

const AgentStatusTop = styled.div<{ state: string }>`
  width: 100%;
  height: ${dxpLayout.workItemHeaderHeight};
  display: flex;
  align-items: center;
  padding-left: 1rem;
  border-bottom: 1px solid ${(props) => props.theme.default};
  background-color: ${(props) =>
    props.state === "Idle" ? props.theme.idle : props.theme.break};
`;

const AgentStatusTopTextContainer = styled.div`
  padding-left: 1rem;
  width:calc(100% - 50px);
`;

const AgentStatusBottom = styled.div<{ state: string }>`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) =>
    props.state === "Idle" ? props.theme.idle : props.theme.break};
`;

const AgentStatusBottomTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const StateTextContainer = styled.div`
  font-size: 2.1rem;
  font-weight: 700;
`;

const TimerContainer = styled.div`
  font-size: 2rem;
  font-weight: 400;
`;

const HelpContainer = styled.div`
  font-size: 1rem;
  font-weight: 400;  
`;

const helpFunction = () => {
  window.open('https://telxlta.mcoutput.com/1385634/Content/index.htm');
};

const AgentStatePanelPresenter: FC<IProps> = memo(({ agentProperties }) => {
  const { state, breakName, stateSince } = agentProperties;

  return (
    <RootContainer>
      <AgentStatusTop state={state}>
        <FontAwesomeIcon icon={faStopwatch} />
        <AgentStatusTopTextContainer id="agent_state_header_text">
          {state}
          {breakName ? ` - ${breakName}` : ""}
        </AgentStatusTopTextContainer>
        <HelpContainer>
                <FontAwesomeIcon
                  icon={faQuestionCircle}
                  onClick={helpFunction}
                />
        </HelpContainer>    
      </AgentStatusTop>
      <AgentStatusBottom state={state}>
        <AgentStatusBottomTextContainer>
          <StateTextContainer id="agent_state_body_text">
            {state === "Idle"
              ? "Waiting for incoming tasks"
              : breakName
              ? "You're on break"
              : "Prepare for Tasks"}
          </StateTextContainer>
          <TimerContainer id="agent_state_body_timer">
            {stateSince && <Timer date={stateSince} />}
          </TimerContainer>
        </AgentStatusBottomTextContainer>
      </AgentStatusBottom>
    </RootContainer>
  );
});

export default AgentStatePanelPresenter;
